import { createRoot } from 'react-dom/client';
import 'leaflet/dist/leaflet.css';
import './styles/tokens.css';
import './styles/app.css';
import './styles/production.css';
import { App } from './screens/shell';

createRoot(document.getElementById('root')!).render(<App />);
